






import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DetailRow extends Vue {
  @Prop() label!: string;
  @Prop() val!: string;
  @Prop({ default: false }) critical!: boolean;

  get displayVal() {
    if (!this.val) return "-";
    return this.val === "ya" ? "Ya" : this.val === "tidak" ? "Tidak" : this.val;
  }
}
